import ktb from "./ktb.store";
import ktbPaynet from "./ktb-paynet.store";
import serviceLog from "./service-log.store";

export default {
    ktb,
    ktbPaynet,
    serviceLog
};
